import { useQuery } from '@tanstack/react-query';
import * as CONSTS from './constants';
import * as apiClient from './api-client';

export function useDirectoryApi(auth) {
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [CONSTS.queryKeys.APIS],
    queryFn: () => apiClient.getApis(auth),
    enabled: !auth?.loginPending,
    staleTime: CONSTS.config.STALE_TIME,
    keepPreviousData: true,
    refetchOnMount: false
  });

  return { data, isLoading, isFetching, isError };
}

export function useGroupApi(auth) {
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [CONSTS.queryKeys.GROUPS],
    queryFn: apiClient.getGroups.bind(this, auth),
    enabled: !auth?.loginPending,
    staleTime: CONSTS.config.STALE_TIME,
    cacheTime: CONSTS.config.CACHE_TIME,
    keepPreviousData: true
  });

  return { data, isLoading, isFetching, isError };
}

export function useUserProfile(auth) {
  const uid = auth?.userData?.sub;
  const isEnabled = Boolean(
    auth?.isAuthenticated && !auth?.loginPending && uid && auth?.accessToken
  );

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [CONSTS.queryKeys.USER_PROFILE, uid],
    queryFn: () => apiClient.getUserProfile(auth),
    enabled: isEnabled,
    staleTime: CONSTS.config.STALE_TIME,
    cacheTime: CONSTS.config.CACHE_TIME,
    refetchOnMount: false
  });

  const roles = data?.profile?.roles || [];

  return {
    data,
    roles,
    isLoading: isEnabled && !data && !isError && (isLoading || isFetching),
    isFetching,
    isError
  };
}

